export default __webpack_public_path__ + "static/media/usa2.8df68739.jpg";